import React from 'react';
import StaticPage from './StaticPage.jsx';

const AboutPage = () => (
    <StaticPage
        title="About — Map Shaper"
        description="Map Shaper is a free online tool for building travel maps of visited countries and states, turning a GPS track into a trail map, drawing a road-trip route, and cropping photos into map silhouettes."
        heading="About Map Shaper"
        intro="Map Shaper is a small tool for travellers who like seeing their trips on a map — to download and keep, or order on a cup, t-shirt and more."
    >
        <h2>What you can do here</h2>
        <p>
            Four things, all free to use and no account required — sign up only if you
            want to save your maps and come back to them later.
        </p>
        <ul>
            <li>
                <strong>Travel Maps</strong> — pick a region (USA states, world countries,
                Europe, US National Parks, UK counties, and 20+ more), click the places you've
                visited, and end up with a personalised map you can download or order on a
                product.
            </li>
            <li>
                <strong>Trail Maps</strong> — upload a GPS track (one file, or several for a
                multi-day hike) and we draw it on a topographic basemap, with distance and
                elevation worked out for you.
            </li>
            <li>
                <strong>Road Trips</strong> — search the stops on your trip, drop them in
                order, and we draw the drive between them along real roads.
            </li>
            <li>
                <strong>Photo Shaper</strong> — upload any photo and crop it into the
                silhouette of a state, country, island, or national park. Adjust the framing,
                add an outline, and save the result.
            </li>
        </ul>

        <h2>How orders work</h2>
        <p>
            Products (cups, t-shirts, magnets, coasters, water bottles, and more)
            are printed and shipped by our partner Zazzle. When you order, your design gets
            handed off to their checkout. Payment, production, shipping, and customer
            service all happen there.
        </p>

        <h2>Who built this</h2>
        <p>
            Map Shaper is an independent project. There's no investor pitch, no algorithm,
            no premium tier — just a website that does one specific thing well. If something
            is broken or you want a region added, email{' '}
            <a href="mailto:mapshaped@gmail.com">mapshaped@gmail.com</a>.
        </p>
    </StaticPage>
);

export default AboutPage;
